import { useEffect } from "react";

export const useOpenFilterCanvasShortcut = (
  id,
  { key = "f", alt = false, ctrl = false, shift = false, meta = false } = {}
) => {
  useEffect(() => {
    const handleKey = (e) => {
      if(!e?.key) return;
      const isMatch =
        e?.key?.toLowerCase() === key &&
        !!alt === e.altKey &&
        !!ctrl === e.ctrlKey &&
        !!shift === e.shiftKey &&
        !!meta === e.metaKey; 

      if (!isMatch) return;

      e.preventDefault();

      const el = document.getElementById(id);
      if (!el || !window.bootstrap) return;

      const instance = window.bootstrap.Offcanvas.getOrCreateInstance(el);
      

      el.classList.contains("show") ? instance.hide() : instance.show();
    };

    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [id, key, alt, ctrl, shift, meta]);
};
